import React, {
  Component,
  Fragment
} from 'react';

import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import {
  NavLink
} from 'react-router-dom';

import {
  LogoSection,
  LogoImageWrapper,
  NavbarItem,
  NavbarProfileImg,
  NavbarMobile,
  NavbarMobileItems,
  NavbarWrapper
} from '../HelperComponents/StyledComponents';

import { COLOR_ORANGE, COLOR_CREAM } from '../../constants';
import { logOutAction } from '../../actions/UserActions';

import LogoImg from '../../images/citizen-logo-2025-cream.svg';
import LogoImgOrange from '../../images/citizen-logo-2025-orange.svg';
import personIcon from '../../images/person-icon.png';

class NavbarComponent extends Component {

  static propTypes = {
    user: PropTypes.object,
    dispatch: PropTypes.func,
    history: PropTypes.object
  }

  state = {
    toggleMobileMenu: false
  };


  showMobileMenu =() => {
    this.setState({
      toggleMobileMenu: !this.state.toggleMobileMenu
    });
  }

  hideMobileMenuOnClick = () => {
    this.setState({toggleMobileMenu: false})
  }

  navbarLink = () => {
    if (this.props.user.authenticated) {
      return (
        <Fragment>
          <NavbarItem className="navbar-item is-hidden-touch">
            <NavLink to="/favorites" exact activeClassName="active" className="icon-heart heart-icon" style={{ color: COLOR_ORANGE }}>
            </NavLink>
          </NavbarItem>

          <NavbarItem className="navbar-item is-hidden-touch">
            <NavLink to="/orders" exact activeClassName="active" className="icon-shopping-cart market-icon">
            </NavLink>
          </NavbarItem>
        </Fragment>
      );
    }

    return (
      <Fragment>
        <NavbarItem className="navbar-item">
          <NavLink to="/login" activeClassName="active">
            Login
          </NavLink>
        </NavbarItem>
        <NavbarItem className="navbar-item">
          <NavLink to="/sign-up" activeClassName="active">
            Sign Up
          </NavLink>
        </NavbarItem>
      </Fragment>
    );
  }

  render() {

    return (
      <Fragment>
        <NavbarWrapper className="navbar is-fixed-top is-black" role="navigation" aria-label="dropdown navigation">
          <section className="navbar-brand">
            <NavbarMobile className="is-hidden-desktop">
              <section className="navbar-item">
                <NavLink to="/" style={{ paddingLeft: '.65rem' }}>
                  <LogoImageWrapper>
                    <img className="logo-reg" src={LogoImg} alt="Citizen Logo" width="150px" />
                    <img className="logo-hover" src={LogoImgOrange} alt="Citizen Logo" width="150px" />
                  </LogoImageWrapper>
                </NavLink>
              </section>

              <NavbarMobileItems>
                <a role="button" className={`navbar-burger has-text-white is-pull-right ${this.state.toggleMobileMenu ? 'is-active' : ''} `} aria-label="menu" aria-expanded="false" onClick={this.showMobileMenu}>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                  <span aria-hidden="true"></span>
                </a>
              </NavbarMobileItems>
            </NavbarMobile>
          </section>

          <section className={`navbar-menu ${this.state.toggleMobileMenu ? 'is-active' : ''}`} style={{ background: '#000' }} onClick={this.hideMobileMenuOnClick}>
            <div className="container">
              <div className="columns is-centered" style={{ height: '100%', marginTop: 0, marginBottom: 0 }}>
                <div className="column is-11" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <section className="navbar-start" style={{ zIndex: 1, display: 'flex', alignItems: 'center' }}>
                    <LogoSection className="is-hidden-touch">
                      <NavLink to="/" className="has-text-white is-size-3 is-uppercase">
                        <LogoImageWrapper>
                          <img className="logo-reg" src={LogoImg} alt="Citizen Logo" width="180px" />
                          <img className="logo-hover" src={LogoImgOrange} alt="Citizen Logo" width="180px" />
                        </LogoImageWrapper>
                      </NavLink>
                    </LogoSection>
                  </section>
                  <section className="navbar-end is-hidden-desktop" style={{ width: '100%', padding: '1rem' }}>
                    {this.navbarLink()}
                    {
                      this.props.user.authenticated &&
                      <Fragment>
                        <NavbarItem className="navbar-item">
                          <NavLink to="/profile" activeClassName="active" style={{ display: 'inline-flex', alignItems: 'center' }}>
                            <NavbarProfileImg >
                              <img src={ this.props.user.image || personIcon } className="is-rounded profile-desktop" alt="Profile" />
                            </NavbarProfileImg>
                            <span style={{ marginLeft: '0.5rem' }}>
                              {this.props.user.data.user_display_name}
                            </span>
                          </NavLink>
                        </NavbarItem>
                        <NavbarItem className="navbar-item">
                          <NavLink to="/favorites" exact activeClassName="active" className="icon-heart heart-icon" style={{ color: COLOR_ORANGE }}>
                          </NavLink>
                        </NavbarItem>

                        <NavbarItem className="navbar-item">
                          <NavLink to="/orders" exact activeClassName="active" className="icon-shopping-cart market-icon">
                          </NavLink>
                        </NavbarItem>
                        <NavbarItem className="navbar-item has-text-white" onClick={() => this.props.logOutAction(this.props.history)}>
                          <a>Logout</a>
                        </NavbarItem>
                      </Fragment>
                    }
                  </section>
                  <section className="navbar-end is-hidden-touch">
                    {this.navbarLink()}
                    {
                      this.props.user.authenticated &&
                      <NavbarItem className="navbar-item is-flex-touch" style={{ justifyItems: 'center', alignItems: 'center', paddingRight: '0 !important' }}>
                        <NavLink to="/profile" activeClassName="active">
                          <NavbarProfileImg >
                            <img src={ this.props.user.image || personIcon } className="is-rounded profile-mobile" alt="Profile" />
                          </NavbarProfileImg>
                        </NavLink>
                      </NavbarItem>
                    }
                  </section>
                </div>
              </div>
            </div>
          </section>
        </NavbarWrapper>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  const {
    isFetching,
    lastUpdated,
  } = user || {
    isFetching: true,
    authenticated: false
  };

  return {
    user,
    isFetching,
    lastUpdated
  };
}

export const Navbar = withRouter(connect(mapStateToProps, { logOutAction })(NavbarComponent));


// WEBPACK FOOTER //
// ./src/components/Navbar/Navbar.js